import { useSelector } from 'react-redux';

export const useNotificationScript = () => {
  const { userInfo } = useSelector((state) => state.user);

  return (userInfo && !userInfo.guest) ? `var url_param_token = "${userInfo?.idToken}";
  var connection = new signalR.HubConnectionBuilder().withUrl("${process.env.REACT_APP_NOTIFICATION_SCRIPT}", { accessTokenFactory: () => url_param_token }).build();
  connection.on("ReceiveMessage", function (event, message) {
      try {
        const orderIdData = JSON.parse(message);
        if(orderIdData.event==="purchase.completed"){
          localStorage.setItem('orderId', orderIdData.data.order);
        }
      } catch (e) {
        return false;
      }
  });
  connection.start().then(function () {
      //wharever you need
  }).catch(function (err) {
      return console.error(err.toString());
  });` : null;
};
